"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GvfClient = void 0;
const GvfNetworkError_1 = require("./errors/GvfNetworkError");
const UserNotAuthorizedError_1 = require("./errors/UserNotAuthorizedError");
const UnknownVehicleError_1 = require("./errors/UnknownVehicleError");
const NotPrimaryUserError_1 = require("./errors/NotPrimaryUserError");
class GvfClient {
    constructor(localeService, authService, stage) {
        this.localeService = localeService;
        this.authService = authService;
        this.stage = stage;
        this.resourceHostId = `cwat-group-vehicle-file-service-${this.stage}`;
    }
    async getGvfData(vehicleId) {
        const path = `vehicles/${vehicleId}/data/${this.localeService.language}-${this.localeService.countryCode}`;
        return await this.callGvfEndpoint(path);
    }
    async getGvfDetails(vehicleId) {
        const path = `vehicles/${vehicleId}/details/${this.localeService.language}-${this.localeService.countryCode}`;
        return await this.callGvfEndpoint(path);
    }
    async getGvfPrNumber(vin) {
        // The key is always 'MOT'. https://devstack.vwgroup.com/jira/browse/WEMYVW-339
        const url = `vehicles/${vin}/product-codes?family=MOT`;
        const resourceHostId = `cwat-group-vehicle-file-service-${this.stage}`;
        const response = await this.authService.get(resourceHostId, url);
        if (!response.ok) {
            throw new Error(`Request to product codes failed with status code ${response.status}`);
        }
        return await response.json();
    }
    async callGvfEndpoint(path) {
        let response;
        try {
            response = await this.authService.get(this.resourceHostId, path);
        }
        catch (e) {
            if (e.message === 'Network Error' || e.code === 'ECONNABORTED') {
                throw new GvfNetworkError_1.GvfNetworkError();
            }
        }
        if (!response) {
            throw new GvfNetworkError_1.GvfNetworkError();
        }
        if (response.status === 401) {
            throw new UserNotAuthorizedError_1.UserNotAuthorizedError();
        }
        else if (response.status === 403) {
            throw new NotPrimaryUserError_1.NotPrimaryUserError();
        }
        else if (response.status === 404) {
            throw new UnknownVehicleError_1.UnknownVehicleError();
        }
        else if (!response.ok) {
            throw new Error(response.statusText);
        }
        return await response.json();
    }
}
exports.GvfClient = GvfClient;
//# sourceMappingURL=GvfClient.js.map